<template>
<div class="md:flex flex-wrap min-h-screen">

  <!-- header -->
  <div class="bg-white md:fixed top-0 left-0 w-full h-20 flex items-center botborder z-10 relative">
    <img v-if="$store.state.dash.logoURL"  class="pt_logo w-48 block mx-auto" :src="$store.state.dash.logoURL"/>
    <img v-else  class="w-48 block mx-auto" src="@/assets/images/logo/logo.png"/>
  </div>

  <!-- inputs -->
  <div class="w-full py-6 md:pt-18 md:w-118 lg:w-200 bg-white md:shadow-setupside px-8 lg:px-24 min-h-full">
    <div>

    <div class="pt_stepper mt-10">
      <div class="flex items-center justify-between mb-2">
        <span class="text-sm font-semibold text-primary">Step 1 of 4</span>
        <span class="text-sm text-light">Create your account</span>
      </div>
      <div class="pt_stepbar"><div class="pt_stepbarfill" style="width: 25%;"></div></div>
    </div>

    <h3 class="mt-8 mb-6 relative w-full font-medium pr-12 text-3xl lg:text-4xl inline-block">Create your free account</h3>
    <div class="mt-2 mb-6 flex flex-wrap">
      <span class="pt_benefit"><feather-icon icon="CheckIcon" svgClasses="w-4 h-4 stroke-current text-success" class="mr-2"/>Free forever — upgrade when you need more</span>
      <span class="pt_benefit"><feather-icon icon="CheckIcon" svgClasses="w-4 h-4 stroke-current text-success" class="mr-2"/>No card needed</span>
    </div>

    <div v-if="registerErrorMsg" class="pt_signuperror my-6">
      <p class="text-danger font-medium">{{ registerErrorMsg }}</p>
      <p v-if="suggestLogin" class="mt-1">Want to use that account instead? <a href="" class="text-primary underline font-medium" @click.prevent="$router.push('/dash/login')">Log in here</a>.</p>
    </div>

      <vs-input
        v-validate="'required|min:3|max:20'"
        data-vv-validate-on="blur"
        data-vv-as="First name"
        label="First Name"
        name="displayName"
        placeholder="John"
        v-model="displayName"
        @keyup.enter="registerUser"
        class="w-full" />
        <span class="text-primary my-2">{{ errors.first('displayName') }}</span>

      <vs-input
        v-validate="'required|email|max:60'"
        data-vv-validate-on="blur"
        name="email"
        type="email"
        label="Email"
        placeholder="john@hancock.com"
        v-model="email"
        @keyup.enter="registerUser"
        class="w-full mt-6" />
      <span class="text-primary">{{ errors.first('email') }}</span>

      <div class="relative mt-6">
      <vs-input
        ref="password"
        :type="passwordVisible ? 'text' : 'password'"
        v-validate="'required|min:6|max:64'"
        name="password"
        label="Password"
        placeholder="Choose a password"
        @blur="checkPWAlpha"
        @keyup.enter="registerUser"
        v-model="password"
        class="w-full" />
        <a href="" class="pt_pwtoggle" @click.prevent="passwordVisible = !passwordVisible">{{ passwordVisible ? 'Hide' : 'Show' }}</a>
      </div>
        <span class="text-primary">{{ errors.first('password') ? errors.first('password') : passwordMsg }}</span>
      <vs-button class="w-full font-semibold mt-8 mb-4 pmybtnshdw" size="large" @click="registerUser" :disabled="!validateForm || submitting">{{ submitting ? 'Creating your account...' : 'Create my free account' }}</vs-button>
      <p>By clicking this button, you agree to our <a href="https://feedback.link/tou.html" target="_blank">Terms</a> and <a href="https://feedback.link/privacy.html" target="_blank">Privacy Policy.</a></p>
      <p class="text-center mt-10">Already have an account? <a href="" class="text-primary underline font-medium" @click.prevent="$router.push('/dash/login')">Log in</a></p>

    </div>
  </div>

  <!-- aside -->
  <div class="w-full py-8 md:py-0 md:fixed md:w-full md:top-20 md:pl-118 lg:pl-200 md:pb-20 md:min-h-full z-m1 md:flex items-center icnbg" style="backgroundColor: #FBEFFF;">
    <div class="w-full px-6 text-center suaside text-dark lg:text-lg">
      <div>
        <div class="pt_featurecard">
          <img src="@/assets/images/misc/surs.png" class="w-16 block mx-auto"/>
          <p class="pt_featuretitle">Reviews & Shares</p>
          <p class="pt_featuredesc">Generate online word of mouth. Turn customers into promoters.</p>
          <img class="w-64 mx-auto mt-4" src="@/assets/images/misc/reviewlogos.png"/>
        </div>
      </div>
      <div class="mt-6 lg:mt-10">
        <div class="pt_featurecard">
          <img src="@/assets/images/misc/susc.png" class="w-16 block mx-auto"/>
          <p class="pt_featuretitle">Showcase</p>
          <p class="pt_featuredesc">Improve conversion on your website with Social Proof widgets.</p>
        </div>
      </div>
      <div class="mt-6 lg:mt-10">
        <div class="pt_featurecard">
          <img src="@/assets/images/misc/sus.png" class="w-16 block mx-auto"/>
          <p class="pt_featuretitle">Survey</p>
          <p class="pt_featuredesc">Discover new ideas and fresh perspectives through customer feedback.</p>
        </div>
      </div>
    </div>
  </div>

</div>
</template>

<script>


function isAlphaNumeric(myString) {
  return (/\d/.test(myString) && (myString.match(/[a-z]/i)))
}

export default {
  data () {
    return {
      registerErrorMsg: false,
      suggestLogin: false,
      submitting: false,
      passwordVisible: false,
      displayName: '',
      email: '',
      password: '',
      confirm_password: '',
      isTermsConditionAccepted: true,
      passwordMsg: ''
    }
  },
  watch: {
    password() {
      this.passwordMsg = ''
      this.registerErrorMsg = false
      this.suggestLogin = false
    },
    email() {
      this.registerErrorMsg = false
      this.suggestLogin = false
    }
  },
  computed: {
    validateForm () {
      return this.passwordMsg === '' && !this.errors.any() && this.displayName !== '' && this.email !== '' && this.password !== '' && this.isTermsConditionAccepted === true
    }
  },
  methods: {
    checkPWAlpha () {
      if (this.password !== '') {
        if (!isAlphaNumeric(this.password)){
          this.passwordMsg = 'Your password should contain at least one number and one letter.'
        }
      }
    },
    setErrorMessage (msg){
      this.registerErrorMsg = msg
    },
    registerUser () {

      if (!this.validateForm || this.submitting) return

      this.registerErrorMsg = false
      this.suggestLogin = false
      this.submitting = true
      this.$vs.loading()

      const payload = {
        userDetails: {
          displayName: this.displayName,
          email: this.email,
          password: this.password
        }
      }

      this.$store.dispatch('auth/registerUser', payload).then(() => {

        this.$vs.loading.close()
        this.$router.push('/dash/setup')

      }).catch((e) => {

        this.$vs.loading.close()
        this.submitting = false

        const msg = typeof e === 'string' ? e : ''

        if (msg.indexOf('already in use') !== -1) {
          this.registerErrorMsg = 'There\'s already an account with that email address.'
          this.suggestLogin = true
        } else if (msg.indexOf('badly formatted') !== -1) {
          this.registerErrorMsg = 'That email address doesn\'t look right — please double-check it.'
        } else if (msg.toLowerCase().indexOf('password') !== -1) {
          this.registerErrorMsg = msg
        } else {
          this.registerErrorMsg = 'We couldn\'t create your account. Please try again — if it still doesn\'t work, email us at support@feedback.link.'
        }

      })

    }
  }
}

</script>


<style lang="scss">

  .pt_benefit {
    display: inline-flex;
    align-items: center;
    background: rgba(var(--vs-success), 0.08);
    border-radius: 100px;
    padding: 0.4rem 0.95rem;
    margin: 0 0.5rem 0.5rem 0;
    font-size: 0.92rem;
    font-weight: 500;
  }

  .pt_featurecard {
    display: inline-block;
    background: rgba(255, 255, 255, 0.78);
    border-radius: 18px;
    padding: 1.5rem 2rem;
    max-width: 26rem;
    box-shadow: 0 10px 30px rgba(103, 3, 227, 0.07);
  }

  .pt_featuretitle {
    font-size: 1.25rem;
    font-weight: 600;
    margin-top: 0.75rem;
  }

  .pt_featuredesc {
    margin-top: 0.35rem;
    font-weight: 500;
  }

  .pt_pwtoggle {
    position: absolute;
    top: -0.25rem;
    right: 0;
    color: #A7A7A7;
    font-size: 0.87rem;
    text-decoration: underline;
  }

  .pt_stepper {
    .pt_stepbar {
      height: 6px;
      background: #EFEFEF;
      border-radius: 3px;
      overflow: hidden;
    }
    .pt_stepbarfill {
      height: 100%;
      border-radius: 3px;
      background: rgba(var(--vs-primary), 1);
      transition: width 0.4s ease;
    }
  }

</style>
